<!-- eslint-disable vue/no-parsing-error -->
<template>
  <!-- class="aff-report-container" -->
  <v-card style="padding: 4px;">
    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date"
      @change="changeMonth(date)" transition="scale-transition" offset-y min-width="auto">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field v-model="date" label="Time" prepend-icon="mdi-calendar" readonly v-bind="attrs"
          v-on="on"></v-text-field>
      </template>
      <v-date-picker v-model="date" no-title scrollable type="month" :month-format="formatMonth">
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">
          Cancel
        </v-btn>
        <v-btn text color="primary" @click="changeMonth($refs.menu, date)">
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
    <!-- <div class="aff-table pt-2 pl-5 " style=" background:transparent!important">
      <h5 class=" text-black text-uppercase text-underline text-left">Player Statement</h5>
    </div> -->
    <!-- <v-data-table hide-default-header id="aff-table" class="aff-table elevation-1 border-1 " item-key="_id"
      :mobile-breakpoint="100" :headers="headersReportAff" :items="getAffReport ? [getAffReport] : []"
      :server-items-length=1 :loading="getLoading" hide-default-footer>

      <template v-slot:header="{ props }">
        <th v-for="(header, index) in props.headers" :key="index" class="text-center aff-header-style">
          <h6 class="m-0 pt-14 pb-3">{{ $t(`header.${header.text}`) }}</h6>
        </th>
      </template>
      <template v-slot:[`item.total_betting_record`]="{ item }">
        <h5 class="py-3">{{ item.total_betting_record }}</h5>
      </template>
      <template v-slot:[`item.total_win_lose`]="{ item }">
        <h5 class="py-3" :style="item.total_win_lose < 0 ? ' color:red' : ''">
          {{ item.total_win_lose }}
        </h5>
      </template>
      <template v-slot:[`item.total_turnover`]="{ item }">
        <h5 class="py-3">{{ formatMoney(item.total_turnover) }}</h5>
      </template>
      <template v-slot:[`item.total_comission`]="{ item }">
        <h5 class="py-3"> <span style="background-color: #ffff01" class="px-5 py-2">{{ item.total_comission <= 0
      ? '0.00' : item.total_comission }}</span>
        </h5>
      </template>
    </v-data-table> -->
    <v-container class="bg-surface-variant">
      <v-row
        align="center"
        style="height: 150px;"
        no-gutters>
        <v-col cols="6" sm="3">
          <v-card style="height: 100px; background-color: #17cab7; margin: 2px;">
            <v-container align=""center>
              <h5>Total Betting Record</h5>
              <div>{{ getAffReport.total_betting_record}}</div>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="6" sm="3">
          <v-card style="height: 100px; background-color: brown; margin: 2px;" :style="getAffReport.total_win_lose < 0 ? ' background-color:red' : 'background-color:green'">
            <v-container align=""center>
              <h5>Total Win-Lose</h5>
              <div>{{ getAffReport.total_win_lose }}</div>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="6" sm="3">
          <v-card style="height: 100px; background-color: #f6b53f; margin: 2px;">
            <v-container align=""center>
              <h5>Total Turnover</h5>
              <div>{{ formatMoney(getAffReport.total_turnover) }}</div>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="6" sm="3">
          <v-card style="height: 100px; background-color: #e95d77; margin: 2px;">
            <v-container align=""center>
              <h5>total Comission</h5>
              <div>{{getAffReport.total_comission <= 0 ? '0.00' : getAffReport.total_comission}}</div>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      date: this.moment().format('YYYY-M'),
      menu: false,
      headersReportAff: [
        {
          text: "total_betting_record",
          value: "total_betting_record",
          sortable: false,
          align: "center",
        },
        {
          text: "total_win_lose",
          value: "total_win_lose",
          sortable: false,
          align: "center",
        },
        {
          text: "total_turnover",
          value: "total_turnover",
          sortable: false,
          align: "center",
        },
        {
          text: "total_comission",
          value: "total_comission",
          sortable: false,
          align: "center",
        },
      ],
    };
  },
  computed: {

    ...mapGetters("$_modules", {
      userInfo: "getUserInfo",
    }),
    ...mapGetters("$_affiliate", {
      getAffReport: "getAffReport",
      getLoading: "getLoading",
    }),
  },
  methods: {
    moment,
    formatMonth(date) {
      return this.moment(date).format('M');
    },
    changeMonth(ref, date) {
      ref.save(date);
      const selectDate = {
        month: moment(date).format('M'),
        year: moment(date).format('YYYY')
      }
      this.fetchAffReport(selectDate);
      this.menu = false;
    },
    ...mapActions("$_affiliate", ["fetchAffReport"]),
  },
};
</script>
<style scoped>
#aff-table>>>tr:hover {
  background: #88c5ee63 !important;
  cursor: pointer;
}
</style>